import { render, staticRenderFns } from "./WechatBind.vue?vue&type=template&id=7b345d64&scoped=true"
import script from "./WechatBind.vue?vue&type=script&lang=js"
export * from "./WechatBind.vue?vue&type=script&lang=js"
import style0 from "./WechatBind.vue?vue&type=style&index=0&id=7b345d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b345d64",
  null
  
)

export default component.exports